<script lang='ts' setup>

const props = withDefaults(defineProps<{
    status: 'default' | 'error' | 'loading';
    src: string[];
}>(), {
    status: 'default'
});
</script>

<template>

  <template v-if="props.src.length === 1">
    <div class="popup-img border-400 position-relative img-group"
         :class="{'popup-img__loading': props.status === 'loading'}">
      <div class="img-0 ">
        <ImgMain :src="src[0]"
                 alt="sorceImg" />
      </div>
      <div class="img-1 position-absolute">
        <ImgMain v-if="props.status === 'default'"
                 :src="props.src[0]"
                 alt="sorceImg" />
        <ImgMain v-else-if="props.status === 'error'"
                 :src="props.src[0]"
                 alt="sorceImg" />
        <ImgMain v-else-if="props.status === 'loading'"
                 :src="props.src[0]"
                 alt="sorceImg" />
      </div>
      <!-- Red cross -->
      <div v-if="props.status === 'error'"
           class="error-circle display-flex align-items-center justify-center position-absolute">
        <IconMain class="error-circle__icon"
                  icon="close"
                  :size="28" />
      </div>

      <!-- Loading -->
      <div v-if="props.status === 'loading'"
           class="spinner-container position-absolute">
        <div class="spinner"></div>
      </div>

    </div>

  </template>

  <template v-if="props.src.length > 1">
    <div class="img-group position-relative">
      <div class="img-0 popup-img">
        <ImgMain :src="src[0]"
                 alt="sorceImg" />
      </div>
      <div class="img-1 popup-img border-400 position-absolute">
        <ImgMain :src="src[0]"
                 alt="sorceImg" />
      </div>
      <div class="img-2 popup-img border-400">
        <ImgMain :src="src[1]"
                 alt="sorceImg" />
      </div>
      <div class="img-3 popup-img border-400">
        <ImgMain :src="src[2]"
                 alt="sorceImg" />
      </div>

    </div>
  </template>

  <template v-if="props.src.length === 0">
    <div class="only-icon position-relative">
      <div v-if="props.status === 'error'"
           class="error-circle display-flex align-items-center justify-center position-absolute">
        <IconMain class="error-circle__icon"
                  icon="close"
                  :size="28" />
      </div>
    </div>
  </template>

</template>

<style lang="scss" scoped>
.popup-img {
  width: 120px;
  height: 120px;
  overflow: hidden;
  border: 1px solid var(--content-secondary);

  &__loading {
    opacity: 0.4;
  }
}

.only-icon {
  width: 112px;
  height: 112px;
}

.error-circle {
  top: 50%;
  left: 50%;
  width: 64px;
  height: 64px;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background-color: var(--bg-negative-secondary);

  &__icon {
    color: var(--content-negative);
  }
}

.spinner-container {
  display: flex;
  top: 50%;
  left: 50%;
  align-items: center;
  justify-content: center;
  transform: translate(-50%, -50%);
}

.spinner {
  width: 28px;
  height: 28px;
  animation: spin 1s linear infinite;
  border: 4px solid var(--bg-secondary-inverted);
  border-top: 4px solid var(--bg-brand-aviation-primary);
  border-radius: 50%;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.img-group {
  .img-0 {
    filter: blur(100px);
  }

  .img-1 {
    top: 0;
  }

  .img-2 {
    position: absolute;
    z-index: -1;
    top: 0;
    left: 30px;
    transform: rotate(15deg);
  }

  .img-3 {
    position: absolute;
    z-index: -2;
    top: 0;
    left: -30px;
    transform: rotate(-15deg);
  }
}

</style>
